exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container__subscriptions__duration .v-chip {\n  border-radius: 10px !important;\n}\n.v-alert {\n  padding: 8px !important;\n}\n.v-alert a:link {\n  color: #fff;\n  text-decoration: underline;\n}\n.v-alert a:visited {\n  color: #fff;\n  text-decoration: underline;\n}\n.container__subscriptions__duration {\n  display: flex;\n  justify-content: center;\n}\n.container__subscriptions__duration .v-chip .v-chip__content {\n  cursor: pointer;\n}", ""]);

// exports
